import {Box, Button, buttonClasses, IconButton, styled, Tooltip, Typography} from "@mui/material";
import {CancelRounded, DoneRounded} from "@mui/icons-material";

const ProgressButton = (props) => {

    const {children, downloading, progress, sx, wrapperProps, isCompleted, isFailed, onCancel, startIcon, endIcon, ...restProps} = props;
    const defaultSX = {
        "&:before": {width: progress+"%!important"},
        ...sx,
    }

    return (
        <Box position="relative" {...wrapperProps}>
            <StyledButton
                disabled={downloading && !isCompleted}
                variant="contained" disableElevation
                sx={defaultSX}
                startIcon={!downloading && !isCompleted && startIcon}
                endIcon={!downloading && !isCompleted && endIcon}
                className={`${isFailed ? "Mui-error" : ""}`}
                {...restProps}>
                {isCompleted
                    ?
                    <DoneRounded/>
                    :
                    isFailed
                        ?
                        "خطا، دوباره تلاش کنید"
                        :
                        !downloading
                            ?
                            children
                            :
                            <Box display="flex" alignItems="center" zIndex={1}>
                                {/*<ProgressRing*/}
                                {/*    progress={progress} radius={12} stroke={2}*/}
                                {/*    sx={{ color: theme => theme.palette.primary.main  }}*/}
                                {/*    circleProps={{ sx: { transformOrigin: '50% 0' } }}/>*/}
                                <Typography fontSize=".8rem" fontWeight={600} color="text.primary" sx={{ width: "1.5rem", textAlign: "left" }}>({progress ? progress.toLocaleString("fa-IR") : "۰"}٪)</Typography>
                                <Typography ml={1.5} fontSize="inherit" fontWeight={600} color="text.primary">در حال بارگذاری..</Typography>
                            </Box>
                }
            </StyledButton>
            {!isCompleted && downloading && (
                <Box sx={{ position: "absolute", top: 0, right: 0 }}>
                    <Tooltip title="لغو">
                        <IconButton onClick={onCancel} color="error">
                            <CancelRounded fontSize="small"/>
                        </IconButton>
                    </Tooltip>
                </Box>
            )}
        </Box>
    )
}
const StyledButton = styled(Button)(({theme}) => ({
    "&.Mui-error": {
      background: "transparent!important",
        color: theme.palette.error.main +"!important",
        border: `1px solid ${theme.palette.error.main}!important`
    },
    [`&.${buttonClasses.disabled}`]: {
        backgroundColor: theme.palette.primary.light+"80!important",
        "&:before": {
            content: "''",
            position: "absolute",
            top: 0,
            bottom: 0,
            left: 0,
            width: "0",
            background: 'rgb(0 176 255 / 25%)',
            borderTopLeftRadius: "inherit",
            borderBottomLeftRadius: "inherit",
            transition: "width 0.4s cubic-bezier(0.25, 0.5, 0.5, 1)",
            zIndex: 0
        }
    }
}));
export default ProgressButton;